import { AppShell } from '@mantine/core'
import { Outlet } from 'react-router-dom'
import { Footer } from '@components/Footer/Footer'
import { SettingsShellHeader } from './SettingsShellHeader'
import classes from './SettingsShell.module.css'
import { SettingsShellNavigation } from './SettingsShellNavigation'

export interface SettingsShellProps {
  type: 'account' | 'admin'
}

export const SettingsShell = (props: SettingsShellProps) => {
  const { type } = props

  return (
    <AppShell
      layout="alt"
      header={{ height: 60 }}
      footer={{ height: 40 }}
      navbar={{ width: 225, breakpoint: 0 }}
      aside={{
        width: 300,
        breakpoint: 'xs',
        collapsed: { desktop: false, mobile: false },
      }}
      padding="md"
    >
      <AppShell.Header className={classes.SettingsShell__header}>
        <SettingsShellHeader />
      </AppShell.Header>
      <AppShell.Navbar className={classes.SettingsShell__nav}>
        <SettingsShellNavigation type={type} />
      </AppShell.Navbar>
      <AppShell.Main pt={60} pl={225} pr={0}>
        <Outlet />
      </AppShell.Main>
      <AppShell.Footer p="xs">
        <Footer />
      </AppShell.Footer>
    </AppShell>
  )
}
